import type { DropdownData } from 'src/app/common/components/reactive-form-builder/interfaces/input.interface';
import { list } from 'src/app/common/classes/request-builder';
import { ComunidadesRegantesModel } from 'src/app/models/analisis/comunidadesRegantes.model';
import { FincasModel } from 'src/app/models/form-common/fincas.module';
import { SectorModel } from 'src/app/models/form-common/sector.model';
import { MantenimientoModel } from 'src/app/models/trabajadores/mantenimiento.model';
import { UserModel } from 'src/app/models/usuarios/user.model';
import { Compradores } from 'src/app/models/ventas/compradores.model';
import { VisitasVariedadMesModel } from 'src/app/models/visitas_variedad_mes/visitas_variedad_mes.model';

export class ParcelasListsDefinition {
    public usuarios: DropdownData<UserModel> = list();
    public fincas: DropdownData<FincasModel> = list();
    public sectores: DropdownData<SectorModel> = list();
    public cultivos: DropdownData<VisitasVariedadMesModel> = list();
    public variedades: DropdownData<VisitasVariedadMesModel> = list();
    public cultivosLegacy: DropdownData<VisitasVariedadMesModel> = list();
    public variedadesLegacy: DropdownData<VisitasVariedadMesModel> = list();
    public comercios: DropdownData<Compradores> = list();
    public aplicadores: DropdownData<MantenimientoModel[]> = list();
    public comunidadesRegantes: DropdownData<ComunidadesRegantesModel> = list();
    public origenesAguaRiego: DropdownData<object> = list();
    
    public secanoRegadio: DropdownData<string> = list(
        ['...', null],
        ['Secano', 'S'],
        ['Regadío', 'R']
    );
    public sistemasRiego: DropdownData<string> = list();

    public usoSigpac: DropdownData<string> = list(
        ['...', null],
        ['Corrientes y superficies de agua (AG)', 'AG'],
        ['Viales (CA)', 'CA'],
        ['Cítricos-Frutal (CF)', 'CF'],
        ['Cítricos (CI)', 'CI'],
        ['Cítricos-Frutal de cáscara (CS)', 'CS'],
        ['Cítricos-Viñedo (CV)', 'CV'],
        ['Edificaciones (ED)', 'ED'],
        ['Elemento del Paisaje (EP)', 'EP'],
        ['Frutal de Cáscara-Frutal (FF)', 'FF'],
        ['Frutal de Cáscara-Olivar (FL)', 'FL'],
        ['Forestal (FO)', 'FO'],
        ['Frutal de Cáscara (FS)', 'FS'],
        ['Frutal de Cáscara-Viñedo (FV)', 'FV'],
        ['Frutal (FY)', 'FY'],
        ['Improductivo (IM)', 'IM'],
        ['Invernaderos y cultivos bajo plástico (IV)', 'IV'],
        ['Olivar-Cítricos (OC)', 'OC'],
        ['Olivar-Frutal (OF)', 'OF'],
        ['Olivar (OV)', 'OV'],
        ['Pasto arbolado (PA)', 'PA'],
        ['Pasto arbustivo (PR)', 'PR'],
        ['Pastizal (PS)', 'PS'],
        ['Tierra arable (TA)', 'TA'],
        ['Huerta (TH)', 'TH'],
        ['Frutal-Viñedo (VF)', 'VF'],
        ['Viñedo (VI)', 'VI'],
        ['Olivar-Viñedo (VO)', 'VO'],
        ['Zona concentrada (ZC)', 'ZC'],
        ['Zona urbana (ZU)', 'ZU'],
        ['Zona censurada (ZV)', 'ZV']
    );

    public patron: DropdownData<string> = list<string>(
        ['...', null]
    );

    public patronAguacate: DropdownData<string> = list<string>(
        ['...', null],
        'Ashdot 17',
        'Clon Atkinson',
        'Clon Bounty',
        'Clon Duke-7',
        'Clon Dusa',
        'Clon Thomas',
        'Clon Toro Canyon',
        'Criollo Antillano',
        'Criollo Mexicano',
        'Dgania 117',
        'Duke-7 (Semilla)',
        'Lula',
        'Maoz',
        'Mexicola',
        'Nachar',
        'Topa-Topa',
        'Water-Hole',
        'Zutano'
    );

    public regimenTenencia: DropdownData<string> = list(
        ['...', null],
        'Propiedad',
        'Arrendamiento',
        'Aparcería',
        'Otros'
    );
    public regimenTenenciaProdalbar: DropdownData<string> = list(
        ['...', null],
        'Propiedad',
        'Arrendamiento'
    );

    public patronAlmendro: DropdownData<string> = list(
        ['...', null],
        'Franco de semilla'
    );
    public patronManzano: DropdownData<string> = list(
        ['...', null],
        // Fuji
        'Kiku',
        'Fubrax',
        'Zhen Aztec',
        'San',
        'September Wonder',
        // Gala
        'Brookfield',
        'Scniga',
        'Vinus',
        'Schnicored',
        // Golden'
        'Delicious',
        'Smoothee',
        'Reinders',
        'Parsi',
        // Granny Smith
        'Challenger',
        // Red Delicious
        'Starking',
        'Golden Rose',
        'Jeromine',
        'Scarlet Spur',
        // Reineta
        'Blanca',
        'Parda',
        // Otros patrones
        'M12',
        'M7',
        'M9',
        'MM106'
    );
    public patronMelocotoneroParaguayo: DropdownData<string> = list(
        ['...', null],
        'Franco',
        'GF677',
        'Garmen',
        'Rootpac 40',
        'Rootpac 60'
    );

    public patronMango: DropdownData<string> = list(
        ['...', null],
        '13-1',
        'Banilejo',
        'Criollo',
        'Gomera-1',
        'Gomera-3'
    );
    public patronMelocotonero: DropdownData<string> = list(
        ['...', null],
        'GF-677', 'GxN Garnem', 'Monclart'
    );
    public patronNogal: DropdownData<string> = list(
        ['...', null],
        'Juglans regia', 'Mj209 x Ra'
    );
    public patronCerezo: DropdownData<string> = list(
        ['...', null],
        'Adara', 'Avium', 'Cab6', 'Col', 'Marina-Adara', 'Maxma', 'Santa Lucía', 'Santa Lucía 64'
    );
    public patronCiruelo: DropdownData<string> = list(
        ['...', null],
        'Mariana', 'Melocotonero', 'Mirobolán C'
    );
    public patronCitricos: DropdownData<string> = list(
        ['...', null],
        'C-35', 'Carrizo', 'Citrumelo', 'Citrumelo CPB 4475', 'Cleopatra', 'Forner Alcaide',
        'Macrophylla', 'Naranjo Amargo', 'Naranjo Borde', 'Troyer', 'Volkameriana',
    );
    public patronPera: DropdownData<string> = list(
        ['...', null],
        'BA-29', 'EM-C', 'Franco', 'Membrillero'
    );
    public patronVina: DropdownData<{codigo: string;}> = list( // Portainjerto
    );

    public cama: DropdownData<string> = list( // CartagenaFresh
        ['...', null],
        ['1.80', '1.80'], ['90', '90'], ['60', '60']
    );

    public formatoMomparler: DropdownData<string> = list(
        ['...', null]
        , '104'
        , '102'
        , '40 '
        , '252'
        , '160'
        , '15 '
        , '77 '
        , '51 '
    );

    public sistemaAsesoramiento: DropdownData<string> = list(
        ['...', null],
        ['Agricultura Ecológica', 'AE'],
        ['Producción Integrada', 'PI'],
        ['Certificación Privada', 'CP'],
        ['Agrupación de Tratamiento Integrado en Agricultura', 'ATRIAS'],
        ['Asistida de un Asesor', 'AS'],
        ['Agrupación Oficial Reconocida', 'AO'],
        ['Guías de cultivo', 'GC'],
        ['Asesor individual', 'AI'],
        ['Sin obligación de aplicar la GIP', 'NO']
    );

    public sistemasCultivo: DropdownData<string> = list(
        ['...', null],
        ['Aire libre', '1'],
        ['Malla', '2'],
        ['Cubierta no accesible', '3'],
        ['Invernadero (cubierta accesible)', '4'],
        ['Forestales en rotación corta', '5'],
        ['Micorrizado', '6'],
        ['Acolchado (SG ACE)', '7'],
        ['Enarenado (SG ACE)', '8'],
        ['Bodega Sacos (Setas/champiñones)', '9'],
        ['Bodega Bandejas (Setas/champiñones)', '10'],
        ['Bodega Botellas (Setas/champiñones)', '11'],
        ['Bodega Otros (Setas/champiñones)', '12'],
        ['Nave Sacos (Setas/champiñones)', '13'],
        ['Nave Bandejas (Setas/champiñones)', '14'],
        ['Nave Botellas (Setas/champiñones)', '15'],
        ['Nave Otros (Setas/champiñones)', '16'],
        ['Hoyos (Viñedo Lanzarote)', '17'],
        ['Zanjas (Viñedo Lanzarote)', '18'],
        ['Invernadero (cubierta accesible)+ enarenado', '19'],
    );

    public observacionesForestales: DropdownData<string> = list(
        ['...', null],
        ['EUCALIPTO', '225'],
        ['PAULONIA', '200'],
        ['CHOPO', '116'],
        ['SAUCE', '227'],
        ['ROBINIA', '230'],
        ['MIMBRERA', '442'],
    );
    public uds_bandeja: DropdownData<string> = list(
        ['...', ''],
        ['84', '84'],
        ['144', '144'],
        ['240', '240'],
        ['Semillero', 'Semillero']
    );

    public tipoSiembra: DropdownData<string> = list(
        ['...', null],
        ['Siembra Directa', 'SD'],
        ['Trasplante', 'TR']
    );

    public filtroCultivosYagoAznar = ['CEBADA', 'AVENA', 'OLIVO', 'VIÑA', 'ALMENDRO', 'BARBECHO TRADICIONAL'];

    public formatosViverogest: DropdownData<{ tipo: string; codigo: string; uds_bandeja: number }> = 
    list<{ tipo: string; codigo: string; uds_bandeja: number }>(
        ['...', null],
        ['AF1L',   { tipo: 'bandeja', codigo: 'AF1L',  uds_bandeja: 15 }],
        ['AF28',   { tipo: 'bandeja', codigo: 'AF28',  uds_bandeja: 28 }],
        ['AF35',   { tipo: 'bandeja', codigo: 'AF35',  uds_bandeja: 35 }],
        ['AF45',   { tipo: 'bandeja', codigo: 'AF45',  uds_bandeja: 45 }],
        ['AF54',   { tipo: 'bandeja', codigo: 'AF54',  uds_bandeja: 54 }],
        ['AF60',   { tipo: 'bandeja', codigo: 'AF60',  uds_bandeja: 60 }],
        ['B77',   { tipo: 'bandeja', codigo: 'B77',   uds_bandeja: 77 }],
        ['B96',   { tipo: 'bandeja', codigo: 'B96',   uds_bandeja: 96 }],
        ['C1L',  { tipo: 'maceta', codigo: 'C1L',    uds_bandeja: 1 }],
        ['C1,2L',  { tipo: 'maceta', codigo: 'C1,2L',  uds_bandeja: 1 }],
        ['C1,25L',  { tipo: 'maceta', codigo: 'C1,25L', uds_bandeja: 1 }],
        ['C1,6L',  { tipo: 'maceta', codigo: 'C1,6L',  uds_bandeja: 1 }],
        ['C2L',  { tipo: 'maceta', codigo: 'C2L',    uds_bandeja: 1 }],
        ['C2,5L',  { tipo: 'maceta', codigo: 'C2,5L',  uds_bandeja: 1 }],
        ['C3L',  { tipo: 'maceta', codigo: 'C3L',    uds_bandeja: 1 }],
        ['C3,5L',  { tipo: 'maceta', codigo: 'C3,5L',  uds_bandeja: 1 }],
        ['C5L',  { tipo: 'maceta', codigo: 'C5L',    uds_bandeja: 1 }],
        ['C7,5L',  { tipo: 'maceta', codigo: 'C7,5L',  uds_bandeja: 1 }],
        ['C10L',  { tipo: 'maceta', codigo: 'C10L',   uds_bandeja: 1 }],
        ['C14L',  { tipo: 'maceta', codigo: 'C14L',   uds_bandeja: 1 }],
        ['C15L',  { tipo: 'maceta', codigo: 'C15L',   uds_bandeja: 1 }],
        ['C17L',  { tipo: 'maceta', codigo: 'C17L',   uds_bandeja: 1 }],
        ['C18L',  { tipo: 'maceta', codigo: 'C18L',   uds_bandeja: 1 }],
        ['C20L',  { tipo: 'maceta', codigo: 'C20L',   uds_bandeja: 1 }],
        ['C22L',  { tipo: 'maceta', codigo: 'C22L',   uds_bandeja: 1 }],
        ['C24L',  { tipo: 'maceta', codigo: 'C24L',   uds_bandeja: 1 }],
        ['C25L',  { tipo: 'maceta', codigo: 'C25L',   uds_bandeja: 1 }],
        ['C35L',  { tipo: 'maceta', codigo: 'C35L',   uds_bandeja: 1 }],
        ['C45L',  { tipo: 'maceta', codigo: 'C45L',   uds_bandeja: 1 }],
        ['C50L',  { tipo: 'maceta', codigo: 'C50L',   uds_bandeja: 1 }],
        ['C55L',  { tipo: 'maceta', codigo: 'C55L',   uds_bandeja: 1 }],
        ['CONT', { tipo: 'maceta', codigo: 'CONT', uds_bandeja: 1 }],
    );
}